import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

interface BIPEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed" }>;
}

const DISMISS_KEY = "watts_install_dismissed";

export function InstallPrompt() {
  const [evt, setEvt] = useState<BIPEvent | null>(null);
  const [visible, setVisible] = useState(false);
  const [iosHint, setIosHint] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (localStorage.getItem(DISMISS_KEY)) return;

    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      (window.navigator as any).standalone === true;
    if (isStandalone) return;

    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (!isMobile) return;
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    const onPrompt = (e: Event) => {
      e.preventDefault();
      setEvt(e as BIPEvent);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);

    const timer = setTimeout(() => {
      setVisible(true);
      if (isIOS) setIosHint(true);
    }, 30_000);

    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      clearTimeout(timer);
    };
  }, []);

  const dismiss = () => {
    setVisible(false);
    localStorage.setItem(DISMISS_KEY, "1");
  };

  const install = async () => {
    if (!evt) return;
    await evt.prompt();
    const { outcome } = await evt.userChoice;
    if (outcome === "accepted") dismiss();
    else setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-x-3 bottom-20 z-[55] sheet-up">
      <div className="rounded-2xl border border-border bg-[#1a1a1a]/95 p-4 backdrop-blur-md shadow-2xl">
        <div className="flex items-start gap-3">
          <div className="rounded-xl bg-primary/15 p-2 text-primary"><Download className="h-5 w-5" /></div>
          <div className="flex-1">
            <div className="font-display text-base font-bold">Instala Watts en tu móvil</div>
            <div className="mt-0.5 text-xs text-white/60">
              {iosHint
                ? "Pulsa Compartir → Añadir a pantalla de inicio."
                : "Una mejor experiencia, acceso desde la pantalla de inicio."}
            </div>
          </div>
          <button onClick={dismiss} aria-label="Cerrar" className="rounded-full bg-surface-elevated p-1.5">
            <X className="h-4 w-4" />
          </button>
        </div>
        {!iosHint && evt && (
          <button
            onClick={install}
            className="press-scale mt-3 w-full rounded-xl bg-primary py-2.5 text-sm font-bold text-primary-foreground"
          >
            Instalar
          </button>
        )}
        {!evt && !iosHint && (
          <button
            onClick={dismiss}
            className="mt-3 w-full text-xs text-white/40"
          >
            Ahora no
          </button>
        )}
      </div>
    </div>
  );
}
